import { useTranslation } from 'react-i18next'
import { useAuth } from '@/lib/AuthContext'
import { contentLanguageLabel, contentLanguageShort, sortContentLanguages } from '@/lib/contentLanguages'
import { cn } from '@/lib/utils'

const TEAM = ['owner', 'admin', 'moderator', 'finance']

/**
 * F-252: the languages a section or space is restricted to, for the team only
 * (the team sees every language; anybody else only gets what is theirs, so a
 * tag would say nothing to them). Nothing when the content is for everyone.
 */
export function LanguageTag({ languages, className }: { languages?: string[] | null; className?: string }) {
  const { t } = useTranslation('common')
  const { hasRole } = useAuth()
  if (!languages?.length || !hasRole(TEAM)) return null
  const sorted = sortContentLanguages(languages)
  const label = t('contentLanguages.tag', { languages: sorted.map(contentLanguageLabel).join(', ') })
  return (
    <span
      title={label}
      aria-label={label}
      className={cn('inline-flex max-w-[6.5rem] flex-shrink-0 items-center truncate rounded bg-muted px-1 py-px text-[10px] font-medium leading-4 text-foreground-secondary', className)}
      data-language-tag={sorted.join(',')}
    >
      {sorted.map(contentLanguageShort).join(' · ')}
    </span>
  )
}
